import React from 'react';
import { Box, BoxProps } from '@mui/material';

const PageContainer: React.FC<BoxProps> = ({ children, ...props }) => (
  <Box
    sx={{
      minHeight: '100vh',
      py: 1.5,
      px: 0, // Remove horizontal padding to maximize width
      ...props.sx
    }}
    {...props}
  >
    {children}
  </Box>
);

export default PageContainer;
